<template>
  <div>
    <HeaderCreditor header="รายละเอียดการชำระเงิน" :img_header="header_image" link_back="creditor/transferfromdebtor"/>
    <Transfer_incorrect/>
  </div>
</template>

<script>
import HeaderCreditor from "@/components/admin/creditor/headercreditor/HeaderCreditor";
import HeaderImage from "@/assets/money_creditor.png";
import Transfer_incorrect from "@/components/admin/creditor/Transfer_incorrect";
export default {
  name: "TransferIncorrect",
  components: {
    Transfer_incorrect,
    HeaderCreditor
  },
  data() {
    return {
      header_image: HeaderImage,
    }
  }
}
</script>

<style scoped>

</style>
